import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

const KEY = (pid: string) => ['projects', pid, 'team'] as const;

export function useProjectTeam(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/team`),
    enabled: !!projectId,
  });
}

export function useCreateTeamMember(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => apiClient.post(`/api/v1/projects/${pid}/team`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useUpdateTeamMember(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      apiClient.patch(`/api/v1/projects/${pid}/team/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteTeamMember(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/api/v1/projects/${pid}/team/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
